import type React from "react";
import { useEffect, useState } from "react";
import { DialogContent } from "../styles";

interface ModalContentProps {
  id?: string;
  children?: React.ReactNode;
}

const ModalContent = ({ id, children, ...props }: ModalContentProps) => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (id) {
      setElement(document.getElementById(id));
    }
  }, [id]);

  return (
    <DialogContent
      id={id}
      aria-labelledby="customized-modal-content"
      sx={{ pt: "8px !important" }}
      element={element}
      {...props}
    >
      {children}
    </DialogContent>
  );
};

export default ModalContent;
